import { useMutation } from "@tanstack/react-query";
import entryPointService from "../api/entryPointService";

export const useCreateSeedData = () => {
  const { createSeedData } = entryPointService();

  return useMutation({
    mutationKey: ["create-seed-data"],
    mutationFn: async () => {
      const response = await createSeedData();
      return response.data;
    },
  });
};
